import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Globals } from '../../../global-variables/globals';

export interface InformativeDialogData {
  message: string;
}

@Component({
  standalone: false,
  selector: 'app-informative-dialog',
  templateUrl: './informative-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./informative-dialog.component.css']
})
export class InformativeDialogComponent {
  constructor(
    public globals: Globals,
    private dialogRef: MatDialogRef<InformativeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InformativeDialogData
  ) {}

  close() {
    this.dialogRef.close();
  }
}
